module.exports = __webpack_public_path__ + "static/media/titans-silhouette.5ff6ba23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/titans-silhouette.svg
// module id = 1337
// module chunks = 0